const Config = Object.freeze({
  BACKEND_URL: import.meta.env.VITE_API_URL || 'http://localhost:5001',
  TIME_ZONE: 'Europe/Bucharest',
});
export default Config;
